// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.h3PeaIvDlSC5qSdBzW2A svg path {
  stroke: black;
}

.dIeNXgCuNGbn6GVlpFtH svg path {
  stroke: white;
}`, "",{"version":3,"sources":["webpack://./src/components/RouteLayersPopoverContent/index.module.scss"],"names":[],"mappings":"AAEI;EACE,aAAA;AADN;;AAOI;EACE,aAAA;AAJN","sourcesContent":[".svg_path_stroke_black {\n  svg {\n    path {\n      stroke: black\n    }\n  }\n}\n.svg_path_stroke_white {\n  svg {\n    path {\n      stroke: white\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"svg_path_stroke_black": `h3PeaIvDlSC5qSdBzW2A`,
	"svg_path_stroke_white": `dIeNXgCuNGbn6GVlpFtH`
};
export default ___CSS_LOADER_EXPORT___;
